import { Section } from 'components/navigation/subheader/SectionsNavigation';
import { DealType, IOfficeAward } from 'utils/entities';

export type OfficeBulletinType = 'bulletin' | 'commercialBulletin';

export interface IOfficeHeaderInfo {
  agentId?: string;
  address?: string;
  title: string;
  phone: string;
  logo?: string;
  isLeadingAgent?: boolean;
  sections?: Section[];
  activeSection?: Section;
  setContactOpen?: (open: boolean) => void;
  officeName?: string;
  officeLogo?: string;
  officeId?: string;
  agentSubtitle?: string;
  pageDetails?: PageDetails;
  onShareClick?: (event: string, category: string, source: string, pageDetails: PageDetails) => void;
  onShareOptionClick?: (event: string, category: string, source: string, pageDetails: PageDetails, method: string) => void;
  onPhoneExpose?: (source: string, data: any) => void;
}

export interface IOfficeAbout {
  awards?: IOfficeAward[];
  about: {
    title: string;
    description: string;
  };
}

export interface IAgentAbout {
  agentId: string;
  officeId: string;
  name: string;
  title: string;
  licenseId: string;
  licenseFromYear: string;
  description: string;
  logo: string;
  officeLogo: string;
  officeName: string;
  phone: string;
  pageDetails?: PageDetails;
  isLeadingAgent: boolean;
}

export interface IAgentOfficeImages {
  img: string;
  address: string;
  id: string;
  dealType: DealType;
  bulletinType: OfficeBulletinType;
}

export interface IContactInfo {
  name?: string;
  logo?: string;
  phone?: string;
  title?: string;
  isAgent?: boolean;
}

export interface Images {
  img: string;
  address: string;
  id: string;
  dealType: DealType;
  bulletinType: OfficeBulletinType;
}

export interface PageDetails {
  agent_details?: {
    id?: string;
    name?: string;
    is_free?: boolean;
    company_name?: string;
    email?: string;
    multiple_open_house_listings?: boolean;
    is_leading_agent?: boolean;
    number_of_open_house?: number;
    office_id?: string;
    office_name?: string;
    phone_number?: string;
    title?: string;
  };
  office_details?: {
    id?: string;
    name?: string;
    is_free?: boolean;
  };
}

export enum Direction {
  Left = 'left',
  Right = 'right',
}

export enum Action {
  Click = 'click',
  Swipe = 'swipe',
}

export interface EventProps {
  event: 'office_carousel_scroll' | 'agent_carousel_scroll';
  category: 'agent' | 'office';
  direction: Direction;
  action: Action;
  pageDetails: PageDetails;
}
